<section class="tw-m-[20px] !tw-w-[450px]">
  <div class="tw-flex">
    <ul
      class="list-group tw-ml-3 tw-w-1/2 tw-rounded *:dark:tw-text-gray-100 *:tw-flex *:tw-justify-between *:tw-items-center *:tw-py-3 *:flex-wrap"
    >
      <!-- totalCount -->
      <li class="list-group-item list-group-bg">
        <span>{{ pageVocabs + "recipientCount" | translate }} </span>
        <span class="value">{{ model?.recipientCount | numberSeparator }}</span>
      </li>

      <!-- smsParts -->
      <li class="list-group-item list-group-bg">
        <span>{{ pageVocabs + "smsParts" | translate }} </span>
        <span class="value">{{ model?.smsParts | numberSeparator }}</span>
      </li>

      <!-- mciCount -->
      <li class="list-group-item list-group-bg">
        <div class="tw-flex-center">
          <span class="tw-ml-1"
            >{{ pageVocabs + "mciCount" | translate }}
          </span>
          <img [src]="mciImage" class="tw-mx-1" width="20" alt="mci" />
        </div>
        <span class="value">{{ model?.mciCount | numberSeparator }}</span>
      </li>
    </ul>

    <ul
      class="list-group tw-w-1/2 tw-rounded *:dark:tw-text-gray-100 *:tw-flex *:tw-justify-between *:tw-items-center *:tw-py-3 *:flex-wrap"
    >
      <!-- mtnCount -->
      <li class="list-group-item list-group-bg">
        <div class="tw-flex-center">
          <span class="tw-ml-1"
            >{{ pageVocabs + "mtnCount" | translate }}
          </span>
          <img
            src="/assets/media/svg/operator/mtn.svg"
            class="tw-mx-1"
            width="20"
            alt="mtn"
          />
        </div>
        <span class="value">{{ model?.mtnCount | numberSeparator }}</span>
      </li>

      <!-- rightelCount -->
      <li class="list-group-item list-group-bg">
        <div>
          <span class="tw-ml-1"
            >{{ pageVocabs + "rightelCount" | translate }}
          </span>
          <img [src]="rightelImage" class="tw-mx-1" width="20" alt="rightel" />
        </div>
        <span class="value">{{ model?.rightelCount | numberSeparator }}</span>
      </li>

      <!-- otherCount -->
      <li class="list-group-item list-group-bg">
        <span>{{ pageVocabs + "otherCount" | translate }} </span>
        <span class="value">{{ model?.otherCount | numberSeparator }}</span>
      </li>

      <!-- resolutionOfParliamentPrice -->
      <li class="list-group-item list-group-bg">
        <span
          >{{ pageVocabs + "resolutionOfParliamentPrice" | translate }}
        </span>
        <div class="tw-font-medium tw-text-lg">
          <span>{{
            model?.resolutionOfParliamentPrice | numberSeparator
          }}</span>
          <span>{{ "common.currency" | translate }}</span>
        </div>
      </li>

      <!-- resolutionPrice -->
      <li class="list-group-item list-group-bg">
        <span>{{ pageVocabs + "resolutionPrice" | translate }} </span>
        <div class="tw-font-medium tw-text-lg">
          <span>{{
            model?.sendPrice - model?.resolutionOfParliamentPrice
              | numberSeparator
          }}</span>
          <small class="tw-mr-[2px] ltr:tw-ml-[2px] tw-text-[12px]">{{
            "common.currency" | translate
          }}</small>
        </div>
      </li>

      <!-- sendPrice -->
      <li class="list-group-item list-group-bg">
        <span>{{ pageVocabs + "sendPrice" | translate }} </span>
        <div class="tw-font-medium tw-text-lg">
          <span>{{ model?.sendPrice | numberSeparator }}</span>
          <span>{{ "common.currency" | translate }}</span>
        </div>
      </li>
    </ul>
  </div>

  <!-- smsText -->
  <div
    *ngIf="sendType != SendTypes.P2P && sendType != SendTypes.Dynamic"
    class="list-group-item dark:tw-text-gray-100 tw-border tw-border-gray-200 dark:tw-border-dark-100 dark:tw-bg-dark-200 tw-rounded-md tw-flex tw-justify-start flex-column tw-py-4 tw-my-2 !tw-h-[180px]"
  >
    <div
      class="tw-flex tw-justify-start tw-items-center tw-border-b tw-border-gray-100 dark:tw-border-dark-100 tw-text-gray-700 dark:tw-text-gray-300 tw-pb-2"
    >
      <i class="mdi mdi-message-cog tw-ml-2 tw-mb-1 mdi-20px"></i>
      <span class="tw-font-medium">{{ "common.smsBody" | translate }} </span>
    </div>
    <div
      class="font-vazir-ui tw-pt-5 tw-text-gray-600 dark:tw-text-gray-200 tw-text-[14px] tw-whitespace-pre-line tw-overflow-y-scroll"
      copyToClipboard
      style="direction: rtl"
    >
      {{ model?.smsBody }}
    </div>
  </div>

  <div class="tw-flex tw-justify-between tw-items-center tw-mt-5">
    <!-- cancel -->
    <a
      mat-ripple
      class="btn tw-mx-[5px] button-shadow w-75"
      [themeColor]="'cancel-btn'"
      (click)="onClose()"
    >
      {{ "common.cancel" | translate }}
    </a>

    <!-- Confirmation -->
    <button
      mat-ripple
      class="btn button-shadow tw-w-full btn-hover-rise"
      [themeColor]="'btn'"
      (click)="onSubmit()"
    >
      {{ "common.finalConfirmation" | translate }}
      <i class="fas fa-check tw-mt-1 tw-mr-1"></i>
    </button>
    
  </div>
</section>
